export default{
    config:'Config',
    taxForDoctors : 'Tax Rate For Doctors',
    currencyId : 'Currency',
    taxForHospital : 'Tax Rate For Hospital',
    accountsReceivablePersonals : ' Accounts Receivable Personals',
    clinicServiceIncome : 'Clinic Service Income',
    discount : 'Discount',
    cash : 'Cash',
    poses : 'Account of Pose Devices ',
    commercialPaymentsAccountsDoctors : 'Commercial Payments Accounts Doctors',
    organizationOfTaxDoctorsTax : 'Organization Of Tax Doctors Tax',
    costOfDoctorsServices:'Cost Of Doctors Services',
    organizationOfTaxHospitalsTax : 'Organization Of Tax Hospitals Tax',
    bankCards : 'Bank Cards',
    receivedCash : 'Inbox Account',
    returnFromServicesRendered:'The return account of the provided service ',
    excessReceived : 'Added accounts received ',
    commercialPaymentsAccountsPatients : 'Commercial Accounts _ Patients ',
    hospitalShareFromIncome:'The center share of earned income ',
    sideOfTheHospitalShareFromIncome:'The side of the center share of the earned income ',
    donationClinicReceivableAccount:'Donation Clinic Receivable Account ',
    ipdReceivableAccount:'Side of the IPD Receivable Account ',
    donationClinicReceivedCashAccount:"Receivable Cash Account From Donation Clinic",
    ipdReceivedCashAccount:"Receivable Cash Account From IPD"


}